import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const brandProfile = RepositoryFactory.get("brandProfile");

export default {
  createBrandProfile({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.createBrandProfile(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  uploadBrandProfile({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.uploadBrandProfile(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getBusinessSuites({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.getBusinessSuites(payload);
        commit("GET_BUSINESS_SUITES", data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getBrandProfile({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.getBrandProfile(payload);
        console.log(data.data[0], "brand");
        commit("GET_BRAND_PROFILE", data.data[0]);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getSuites({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.getSuites(payload);
        console.log(data, "Hello");
        commit("GET_SUITES", data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  Ailimit({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await brandProfile.Ailimit(payload);
        console.log(data, "Hello");
        commit("AI_LIMIT", data.data.Ailimit);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
